import { AVAILABLE_LANGUAGES } from '@/constants';
import { SylndrHelpPoint } from '../sylndr-help.types';
import BottomSheetNoPadding from '@/components/shared/bottom-sheet/bottom-sheet-no-padding.component';
import { Dispatch, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';
import { HelpSectionDesc } from './help-detailed-item';
import { StaticImageData } from 'next/image';
import { HelpSectionSteps } from './help-steps';
import SylndrHelpCTAs from './bottomSheet-ctas';
import { useAppSelector } from '@/hook';
import { DisplayedCarInfoInterface } from '@/types';

export const SylndrHelpBottomSheet = ({
    section,
    lang,
    openBottomSheet,
    setOpenBottomSheet,
    inspectionRef,
}: {
    section: SylndrHelpPoint;
    lang: AVAILABLE_LANGUAGES;
    openBottomSheet: boolean;
    setOpenBottomSheet: Dispatch<SetStateAction<boolean>>;
    inspectionRef: React.RefObject<HTMLDivElement>;
}) => {
    const { t } = useTranslation();
    const { selectedCar } = useAppSelector(state => state.checkout);
    const handleTryItLater = () => {
        setOpenBottomSheet(false);
    };
    const scrollToReportSection = () => {
        inspectionRef.current?.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
        });
    };
    const handleScrollToInspectionReport = () => {
        setOpenBottomSheet(false);
        scrollToReportSection();
    };
    return (
        <BottomSheetNoPadding
            open={openBottomSheet}
            setOpen={setOpenBottomSheet}
            className="!rounded-xl overflow-hidden"
        >
            <div className="w-full flex flex-col relative bg-white">
                <div className="bg-gradient-to-b from-emerald-50 via-emerald-50/[60%]">
                    <div className="flex justify-center">
                        <div className="bg-gray-300 rounded-[100px] h-1 w-20 my-3 "></div>
                    </div>

                    {/* <>
                        <VideoEntryPoint
                            t={t}
                            gradient="from-emerald-600/25 from-60% to-emerald-600/10"
                            image={SylndrHelpVideoThumbnail}
                            title={t(
                                `CarProfile.SylndrHelp.VideoEntryPoint.${[
                                    section.key,
                                ]}.title`
                            )}
                            subTitle={t(
                                `CarProfile.SylndrHelp.VideoEntryPoint.${[
                                    section.key,
                                ]}.subTitle`
                            )}
                            passedVidURL={section.videoURL.MOBILE}
                        />
                    </> */}
                </div>

                <div className="p-4">
                    <div className="mb-3">
                        <HelpSectionDesc
                            image={section.icon as StaticImageData}
                            title={section.title[lang]}
                            desc={section.desc[lang]}
                        />
                    </div>
                    <div className="py-2">
                        <HelpSectionSteps section={section} lang={lang} />
                    </div>
                </div>
            </div>
            <SylndrHelpCTAs
                carInfo={selectedCar as unknown as DisplayedCarInfoInterface}
                onClick={
                    section.key === 'ReInspect'
                        ? handleScrollToInspectionReport
                        : handleTryItLater
                }
                ctaTitle={
                    section.key === 'ReInspect'
                        ? t(
                              'CarProfile.SylndrHelp.VideoEntryPoint.ReInspect.cta'
                          )
                        : t(
                              'CarProfile.SylndrHelp.VideoEntryPoint.SafeTransaction.cta'
                          )
                }
            />
        </BottomSheetNoPadding>
    );
};
